/* global jQuery COMPONENTS properties google */

COMPONENTS.SingleLeasingOffice = (function ($) {
  function SingleLeasingOffice () {
    this.isLeasingOfficePage = $('body.single-leasing-office').length > 0
  }

  SingleLeasingOffice.prototype.init = function () {
    // Check that we are on a leasing office page
    if (!this.isLeasingOfficePage) {
      return
    }

    this.leasingOfficeProperties = properties
    this.$leasingOfficeMap = $('[data-ecs-components-control="map-leasingoffice"]')
    this.mapElem = this.$leasingOfficeMap.get(0)

    this.map = null
    this.markers = []
    this.bounds = null

    this.mapArgs = {
      scrollwheel: false,
      maxZoom: 20,
      minZoom: 4,
      disableDefaultUI: true,
      zoomControl: false,
      cameraControl: true,
      streetViewControl: true,
      gestureHandling: 'cooperative'
    }

    this.initMap()
  }

  SingleLeasingOffice.prototype.initMap = function () {
    this.map = new google.maps.Map(this.mapElem, this.mapArgs)
    this.addMarkers()
  }

  SingleLeasingOffice.prototype.addMarkers = function () {
    const component = this
    this.bounds = new google.maps.LatLngBounds()

    for (let i = 0; i < component.leasingOfficeProperties.length; i++) {
      const markerItem = {}
      const propertyLatLng = new google.maps.LatLng(component.leasingOfficeProperties[i].location.lat, component.leasingOfficeProperties[i].location.lng)
      markerItem.title = component.leasingOfficeProperties[i].name
      markerItem.propertyLatLng = propertyLatLng
      markerItem.map = component.map
      markerItem.property = component.leasingOfficeProperties[i].id
      markerItem.markerIcon = this.leasingOfficeProperties[i].marker

      const marker = new google.maps.Marker({
        property: markerItem.property,
        position: markerItem.propertyLatLng,
        title: markerItem.title,
        icon: markerItem.markerIcon,
        map: markerItem.map
      })

      const contentString = `<div class="ecs__components__infowindow">
        <p class="ecs__component-locationsmap__card__name">
          ${markerItem.title}
        </p>
        <p class="ecs__component-locationsmap__card__address">
          ${component.leasingOfficeProperties[i].location.street_address}<br>
          ${component.leasingOfficeProperties[i].location.city} ${component.leasingOfficeProperties[i].location.state}, ${component.leasingOfficeProperties[i].location.postal_code}
        </p>
        <p class="ecs__component-locationsmap__card__link">
          <a href="${component.leasingOfficeProperties[i].link}" target="_blank">Visit Website</a>
        </p>
      </div>`

      marker.infoWindow = new google.maps.InfoWindow({ content: contentString })

      component.bounds.extend(marker.position)
      component.markers.push(marker)
      component.bindMarker(marker)
    }

    component.map.fitBounds(this.bounds)
  }

  SingleLeasingOffice.prototype.bindMarker = function (_marker) {
    const component = this
    google.maps.event.addListener(_marker, 'click', function () {
      for (let i = 0; i < component.markers.length; i++) {
        if (component.markers[i].infoWindow) {
          component.markers[i].infoWindow.close()
        }
      }

      _marker.infoWindow.open({
        anchor: _marker,
        map: component.map,
        shouldFocus: false
      })
    })
  }

  return SingleLeasingOffice
})(jQuery)

document.addEventListener('components_init', function () {
  // Hook into the main components init
  COMPONENTS.singleLeasingOffice = new COMPONENTS.SingleLeasingOffice()
  COMPONENTS.singleLeasingOffice.init()
})
